const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "CusName",
		label: "订货经销商",
		columnwidth: 220,
	},
	{
		prop: "ProviderName",
		label: "授权经销商",
		columnwidth: 220,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 80,
	},
	{
		prop: "TerminalHospital",
		label: "医院",
		columnwidth: 220,
	},
	{
		prop: "Remark",
		label: "备注",
		columnwidth: 100,
	},
	{
		prop: "AuthorityCode",
		label: "授权书编号",
		columnwidth: 130,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 95,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 180,
	},
	{
		prop: "UpdaterName",
		label: "修改人",
		columnwidth: 95,
	},
	{
		prop: "UpdateTime",
		label: "修改时间",
		columnwidth: 180,
	}
	// ,
	// {
	// 	prop: "Operate",
	// 	label: "操作",
	// 	columnwidth: 150,
	// 	fixed: "right",
	// },
];
export default headerData;
